<script>
  import { fade } from "svelte/transition";
  import { calculatorStore } from "../store/calculators.js";
  import { inputVariableStore } from "../store/inputVariables.js";
  import { outputVariableStore } from "../store/outputVariables.js";
  import { createEventDispatcher, getContext } from "svelte";
  import FadeIn from "../SharedComponents/FadeIn.svelte";
  import TitleWithHelp from "../SharedComponents/TitleWithHelp.svelte";
  import * as util from "../js/util.js";

  import { langTextStore } from "../store/langtexts.js";
  import { factoryStore } from "../store/factories.js";
  import { numberFormatStore } from "../store/numberFormat.js";
  export let isFactory;
  export let activeSection = "";
  const { snackbar } = getContext("app");
  const dispatch = createEventDispatcher();
  function formatNumberFromOutputStore(varname) {
    var theVal = $outputVariableStore[varname];
    return $numberFormatStore.formatNumber(theVal, $numberFormatStore.style);
  }

  function getLowestValue(subSection) {
    if (!subSection || !subSection.subSectionNameKey.length > 0) return 0;
    var lowestValue = 1000000000000;
    for (var subSectionVarIndex in subSection.variables) {
      var subSectionVar = subSection.variables[subSectionVarIndex];
      var baseVal =
        $outputVariableStore.scenarioConfiguration.calculatedScenarios["base"][
          subSectionVar.nameKey
        ];
      if (subSectionVar.dataType == "percent") baseVal = baseVal * 100;
      if (subSectionVar.dataType == "currency")
        baseVal = baseVal / $inputVariableStore.alternateCurrencyRate;

      if (baseVal < lowestValue) lowestValue = baseVal;
      var targetVal =
        $outputVariableStore.scenarioConfiguration.calculatedScenarios[
          "target-wage"
        ][subSectionVar.nameKey];
      if (subSectionVar.dataType == "percent") targetVal = targetVal * 100;
      if (subSectionVar.dataType == "currency")
        targetVal = targetVal / $inputVariableStore.alternateCurrencyRate;
      if (targetVal < lowestValue) lowestValue = targetVal;
    }
    return lowestValue;
  }
  function formatNumberFromScenario(
    scenario,
    varname,
    thestore,
    whatisthis,
    whatisthis2,
    whatisthis3,
    style,
    subSection
  ) {
    var theScenario =
      $outputVariableStore.scenarioConfiguration.calculatedScenarios[scenario];
    var decimalCount = null;
    if (subSection != undefined) {
      var lowestValue = getLowestValue(subSection);
      decimalCount = lowestValue < 5 ? 4 : lowestValue < 1000 ? 2 : 0;
    }
    var theVal = theScenario[varname];
    var theVar = $calculatorStore.variables.find(
      (v) => v.varNameKey == varname
    );
    if (theVar.dataType == "percent") {
      return (
        "%&nbsp;" + $numberFormatStore.formatNumber(theVal * 100, decimalCount)
      );
    }
    if (theVar.dataType == "currency") {
      if (
        $factoryStore.currentCalculator.alternateCurrencyId &&
        $factoryStore.currentCalculator.alternateCurrencyId > 0 &&
        $inputVariableStore.alternateCurrencyRate > 0
      ) {
        var currencyNameObj = $factoryStore.currencies.find(
          (c) => c.id == $factoryStore.currentCalculator.alternateCurrencyId
        );
        var currencySign = "";
        if (currencyNameObj != null) {
          currencySign = currencyNameObj.htmlCode;
          // '<span class="prelabel prelabel-summary ' +
          // currencyNameObj.nameKey.toLowerCase() +
          // '"></span>';
        }
        return (
          currencySign +
          " " +
          $numberFormatStore.formatNumber(
            theVal / $inputVariableStore.alternateCurrencyRate,
            decimalCount
          )
        );
      }
      var currencySign = "";
      var currencyNameObj = $factoryStore.currencies.find(
        (c) => c.id == $factoryStore.currentCalculator.currencyId
      );
      if (currencyNameObj != null) {
        currencySign = currencyNameObj.htmlCode;

        // '<span class="prelabel prelabel-summary ' +
        // currencyNameObj.nameKey.toLowerCase() +
        // '"></span>';
      }
      return currencySign + " " + $numberFormatStore.formatNumber(theVal, 0);
    }
    return $numberFormatStore.formatNumber(theVal, 0);
  }

  function saveAsFactorySetting(scenarioName) {
    var fullTempName =
      $factoryStore.currentCalculator.name + " - " + scenarioName;
    var settingsCopy = factoryStore.makeInMemoryCopyOfFactorySetting(
      $factoryStore.currentCalculator
    );
    settingsCopy.name = fullTempName;
    for (var theVar in $inputVariableStore.scenarioConfiguration
      .scenarioVarValues[scenarioName]) {
      settingsCopy.variables.find((v) => v.varNameKey == theVar).value =
        $inputVariableStore.scenarioConfiguration.scenarioVarValues[
          scenarioName
        ][theVar];
    }
    factoryStore.saveFactoryOrProductSettings(settingsCopy);
    snackbar(
      "info",
      "saved scenario as factory settings you can find it in the dashboard"
    );
  }
  export let hideHeader = false;
  $: relevantSubSections = $calculatorStore.subSections.filter(
    (ss) => ss.isSummarySection && ss.isFactorySection == isFactory
  );
</script>

<div class="pl-3 summary">
  {#if !hideHeader}
    <h2 class="highlight">
      {$langTextStore.getText("general-header-summary")}
    </h2>
  {/if}
  <div class="w-100">
    <div class="row g-0 text-small mb-3 mb-lg-0">
      <div class="col-12 col-lg-6" />
      <div
        class="col-4  {activeSection == 'scenarios'
          ? 'col-lg-2'
          : 'col-lg-3'} text-right  text-gray-6"
      >
        {#if $inputVariableStore.scenarioConfiguration}
          {#if $inputVariableStore.scenarioConfiguration.scenarios.length > 0}
            {$langTextStore.getText("legal-min-wage")}
          {/if}
        {/if}
      </div>
      {#if $inputVariableStore.scenarioConfiguration}
        <div
          class="col-4  {activeSection == 'scenarios'
            ? 'col-lg-2'
            : 'col-lg-3'} text-right text-gray-6"
        >
          {$langTextStore.getText("target-wage")}
        </div>
        {#if activeSection == "scenarios"}
          <div class="col-4 col-lg-2 text-right text-gray-6">
            {$langTextStore.getText("alternate")}
          </div>
        {/if}
      {/if}
    </div>
  </div>

  {#each relevantSubSections as subSection}
    <div in:fade={{ duration: 800 }} class="w-100">
      <h3 class="mb-1">
        {util.sentenceCase(
          $langTextStore.getText(
            "general-section-" + subSection.subSectionNameKey.replace(" ", "-")
          ),
          false
        )}
      </h3>
      {#each subSection.variables as variable}
        <div class="row g-0 text-small mb-3 mb-lg-0">
          <div class="col-12 col-lg-6 ">
            <TitleWithHelp {variable} />
          </div>
          {#if $outputVariableStore.scenarioConfiguration && $outputVariableStore.scenarioConfiguration.calculatedScenarios}
            <div
              class="font_mono col-4  {activeSection == 'scenarios'
                ? 'col-lg-2'
                : 'col-lg-3'} text-right"
            >
              <FadeIn
                timeout={200}
                name={$outputVariableStore[variable.nameKey]}
                display={formatNumberFromScenario(
                  "base",
                  variable.nameKey,
                  $outputVariableStore.scenarioConfiguration
                    .calculatedScenarios,
                  $outputVariableStore.scenarioConfiguration
                    .calculatedScenarios["base"][variable.nameKey],
                  $inputVariableStore.alternateCurrencyRate,
                  $inputVariableStore.alternateCurrencyName,
                  $numberFormatStore.style,
                  subSection
                )}
              />
            </div>

            <div
              class="font_mono  col-4 {activeSection == 'scenarios'
                ? 'col-lg-2'
                : 'col-lg-3'} text-right"
            >
              <FadeIn
                timeout={200}
                name={$outputVariableStore.scenarioConfiguration
                  .calculatedScenarios["target-wage"][variable.nameKey]}
                display={formatNumberFromScenario(
                  "target-wage",
                  variable.nameKey,
                  $outputVariableStore.scenarioConfiguration
                    .calculatedScenarios,
                  $outputVariableStore.scenarioConfiguration
                    .calculatedScenarios["target-wage"][variable.nameKey],
                  $inputVariableStore.alternateCurrencyRate,
                  $inputVariableStore.alternateCurrencyName,
                  $numberFormatStore.style,
                  subSection
                )}
              />
            </div>
            {#if activeSection == "scenarios"}
              <div class=" font_mono col-4 col-lg-2 text-right">
                <FadeIn
                  timeout={200}
                  name={$outputVariableStore.scenarioConfiguration
                    .calculatedScenarios["alternate"][variable.nameKey]}
                  display={formatNumberFromScenario(
                    "alternate",
                    variable.nameKey,
                    $outputVariableStore.scenarioConfiguration
                      .calculatedScenarios,
                    $outputVariableStore.scenarioConfiguration
                      .calculatedScenarios["alternate"][variable.nameKey],
                    $inputVariableStore.alternateCurrencyRate,
                    $inputVariableStore.alternateCurrencyName,
                    $numberFormatStore.style,
                    subSection
                  )}
                />
              </div>
            {/if}
          {/if}
        </div>
      {/each}
    </div>
  {/each}
  <!-- {#if activeSection == "scenarios"}
        <div in:fade={{ duration: 800 }} class="w-100">
            <div class="row g-0 text-small mb-3 mb-lg-0">
                <div class="col-12 col-lg-6  ellipsis" title="">&nbsp;</div>
                <div class="col-4 col-lg-2 text-right">&nbsp;</div>
                <div
                    class="col-4 col-lg-2 text-right c-pointer line"
                    on:click={() => {
                        saveAsFactorySetting("target-wage");
                    }}
                >
                    {$langTextStore.getText(
                        "general-label-save-as-factorysetting"
                    )}
                </div>
                <div
                    class="col-4 col-lg-2 text-right c-pointer line"
                    on:click={() => {
                        saveAsFactorySetting("alternate");
                    }}
                >
                    {$langTextStore.getText(
                        "general-label-save-as-factorysetting"
                    )}
                </div>
            </div>
        </div>
    {/if} -->
  <br /><br />
  <!-- {#if $numberFormatStore.style == "euro"}
        <span
            style="cursor:pointer"
            on:click={() => {
                numberFormatStore.setNonEuroStyle();
            }}
            >{$langTextStore.getText("general-click-to-change")}: #<span
                style="font-size:2em">.</span
            >###<span style="font-size:2em">,</span>##</span
        >
    {:else}
        <span
            style="cursor:pointer"
            on:click={() => {
                numberFormatStore.setEuroStyle();
            }}
            >{$langTextStore.getText("general-click-to-change")}: #<span
                style="font-size:2em">,</span
            >###<span style="font-size:2em">.</span>##</span
        >
    {/if} -->
</div>
